import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component HashIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <HashIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <HashIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const HashIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="HashIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M6 10.5h12a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2m0 5h12a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2m3.897 4.575 1.2-16a1 1 0 0 0-1.994-.15l-1.2 16a1 1 0 0 0 1.994.15m5 0 1.2-16a1 1 0 0 0-1.994-.15l-1.2 16a1 1 0 0 0 1.994.15" />
    </svg>
  )
);
HashIcon.displayName = "HashIcon";
export default HashIcon;
